export const htmlToText = (html) => {
  const parser = new DOMParser();
  const parseString = "<html>" + html + "</html>";
  const floatingElement = parser.parseFromString(parseString, "text/xml");
  const string = floatingElement.getElementsByTagName("html")[0].textContent;
  console.log(floatingElement);
  console.log(string);
  return string;
};
